(function(){

  function initMvdCart(){

    const drawer =
      document.getElementById('mvd-cart-drawer');

    const overlay =
      document.getElementById('mvd-cart-overlay');

    if(!drawer || !overlay){
      return;
    }


    const path =
      window.location.pathname;

    const lang =
      path.indexOf('/en') === 0
        ? 'en'
        : path.indexOf('/es') === 0
          ? 'es'
          : 'fr';


    const translations = {

      fr:{
        title:'Mon Panier',
        empty:'Votre panier est vide',
        continue:'Continuer mes achats',

        free:'🎁 Félicitations, vous avez débloqué la livraison offerte !',
        missing:'Plus que {amount} pour profiter de la livraison offerte',

        remove:'Supprimer',
        save:'🏷 Vous économisez {percent} %',

        upsell:'✨ Complétez votre kit de Diamond Painting',

        add:'Ajouter au panier',
        adding:'Ajout...',

        promo:'Un code promo ?',
        promoPlaceholder:'Votre code',
        apply:'Appliquer',
        applying:'Application...',
        promoApplied:'✓ Code promo appliqué',
        promoInvalid:'Ce code promo ne semble pas applicable.',
        promoEmpty:'Saisissez votre code promo.',

        discount:'Remise',
        savings:'Vous économisez',

        checkout:'Passer la commande • {total}',

        delivery:'🚚 Livraison rapide Mondial Relay · 3–5 jours ouvrés',

        threshold:6000,

        locale:'fr-FR',
        currency:'EUR',

        prefix:'',

        collection:'/collections/accessoires-diamond-painting/products.json?limit=250'
      },


      es:{
        title:'Mi carrito',
        empty:'Tu carrito está vacío',
        continue:'Seguir comprando',

        free:'🎁 ¡Enhorabuena! Has conseguido el envío gratis.',
        missing:'Te faltan {amount} para conseguir el envío gratis',

        remove:'Eliminar',
        save:'🏷 Ahorras un {percent} %',

        upsell:'✨ Completa tu kit de Diamond Painting',

        add:'Añadir al carrito',
        adding:'Añadiendo...',

        promo:'¿Tienes un código promocional?',
        promoPlaceholder:'Tu código',
        apply:'Aplicar',
        applying:'Aplicando...',
        promoApplied:'✓ Código promocional aplicado',
        promoInvalid:'Este código promocional no parece aplicarse.',
        promoEmpty:'Introduce tu código promocional.',

        discount:'Descuento',
        savings:'Ahorras',

        checkout:'Finalizar compra • {total}',

        delivery:'🚚 Envío rápido vía InPost · 4–6 días laborables',

        threshold:6000,

        locale:'es-ES',
        currency:'EUR',

        prefix:'/es',

        collection:'/es/collections/accessoires-diamond-painting/products.json?limit=250'
      },


      en:{
        title:'My Cart',
        empty:'Your cart is empty',
        continue:'Continue shopping',

        free:'🎁 Congratulations! You unlocked Free Shipping!',
        missing:'Only {amount} away from Free Shipping',

        remove:'Remove',
        save:'🏷 You save {percent}%',

        upsell:'✨ Complete Your Diamond Painting Kit',

        add:'Add to cart',
        adding:'Adding...',

        promo:'Have a promo code?',
        promoPlaceholder:'Promo code',
        apply:'Apply',
        applying:'Applying...',
        promoApplied:'✓ Promo code applied',
        promoInvalid:'This promo code does not appear to apply.',
        promoEmpty:'Enter your promo code.',

        discount:'Discount',
        savings:'You save',

        checkout:'Checkout • {total}',

        delivery:'📦 French brand • Shipping to the United States',

        threshold:7000,

        locale:'en-US',
        currency:'USD',

        prefix:'/en',

        collection:'/en/collections/accessories/products.json?limit=250'
      }

    };


    const T =
      translations[lang];


    const cartTitle =
      document.getElementById('mvd-cart-title');

    const closeButton =
      document.getElementById('mvd-cart-close');

    const shippingText =
      document.getElementById('mvd-shipping-text');

    const shippingProgress =
      document.getElementById('mvd-shipping-progress');

    const items =
      document.getElementById('mvd-cart-items');

    const empty =
      document.getElementById('mvd-cart-empty');

    const emptyText =
      document.getElementById('mvd-empty-text');

    const continueButton =
      document.getElementById('mvd-cart-continue');

    const upsell =
      document.getElementById('mvd-cart-upsell');

    const upsellTitle =
      document.getElementById('mvd-upsell-title');

    const slider =
      document.getElementById('mvd-upsell-slider');

    const prev =
      document.getElementById('mvd-upsell-prev');

    const next =
      document.getElementById('mvd-upsell-next');

    const promoToggle =
      document.getElementById('mvd-promo-toggle');

    const promoContent =
      document.getElementById('mvd-promo-content');

    const promoSymbol =
      document.getElementById('mvd-promo-symbol');

    const promoTitle =
      document.getElementById('mvd-promo-title');

    const promoInput =
      document.getElementById('mvd-promo-input');

    const promoApply =
      document.getElementById('mvd-promo-apply');

    const promoMessage =
      document.getElementById('mvd-promo-message');

    const activeDiscounts =
      document.getElementById('mvd-active-discounts');

    const activeDiscountsTitle =
      document.getElementById('mvd-active-discounts-title');

    const activeDiscountTags =
      document.getElementById('mvd-active-discount-tags');

    const savingTitle =
      document.getElementById('mvd-saving-title');

    const savingValue =
      document.getElementById('mvd-saving-value');

    const checkout =
      document.getElementById('mvd-checkout');

    const delivery =
      document.getElementById('mvd-delivery');


    cartTitle.textContent = T.title;
    emptyText.textContent = T.empty;
    continueButton.textContent = T.continue;
    upsellTitle.textContent = T.upsell;
    promoTitle.textContent = T.promo;
    promoInput.placeholder = T.promoPlaceholder;
    promoApply.textContent = T.apply;
    activeDiscountsTitle.textContent = T.discount;
    savingTitle.textContent = T.savings;
    delivery.textContent = T.delivery;


    let busy = false;
    let accessoryProducts = null;

    const localizedProducts = {};


    function money(cents){

      return (
        Number(cents || 0) / 100
      ).toLocaleString(
        T.locale,
        {
          style:'currency',
          currency:T.currency
        }
      );

    }


    function safeText(value){

      const temp =
        document.createElement('div');

      temp.textContent =
        String(value || '');

      return temp.innerHTML;

    }


    function openCart(){

      drawer.classList.add('mvd-open');
      overlay.classList.add('mvd-open');

      drawer.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.style.overflow =
        'hidden';

      refresh();

    }


    function closeCart(){

      drawer.classList.remove('mvd-open');
      overlay.classList.remove('mvd-open');

      drawer.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.style.overflow =
        '';

    }


    window.openMvdCart =
      openCart;


    closeButton.onclick =
      closeCart;

    overlay.onclick =
      closeCart;

    continueButton.onclick =
      closeCart;


    document.addEventListener(
      'click',
      function(event){

        const element =
          event.target instanceof Element
            ? event.target
            : event.target.parentElement;

        if(!element){
          return;
        }

        const trigger =
          element.closest(
            'a[href*="/cart"],' +
            'button[aria-controls*="cart" i],' +
            '[aria-label*="cart" i],' +
            '[aria-label*="panier" i]'
          );

        if(!trigger){
          return;
        }

        if(
          trigger.closest(
            '#mvd-cart-drawer'
          )
        ){
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openCart();

      },
      true
    );


    const originalFetch =
      window.fetch.bind(window);


    window.fetch =
      function(resource, options){

        let url = '';

        if(
          typeof resource ===
          'string'
        ){
          url = resource;
        }

        else if(
          resource &&
          resource.url
        ){
          url = resource.url;
        }


        const request =
          originalFetch(
            resource,
            options
          );


        if(
          url.indexOf(
            '/cart/add'
          ) !== -1
        ){

          request
            .then(
              function(response){

                if(
                  response &&
                  response.ok
                ){

                  window.setTimeout(
                    function(){
                      openCart();
                    },
                    120
                  );

                }

              }
            )
            .catch(
              function(){}
            );

        }

        return request;

      };


    async function getCart(){

      const response =
        await originalFetch(
          '/cart.js',
          {
            cache:'no-store'
          }
        );

      if(!response.ok){
        throw new Error('Cart error');
      }

      return response.json();

    }


    async function getLocalizedProduct(item){

      if(
        lang === 'fr'
      ){

        return {
          title:item.product_title
        };

      }


      const handle =
        item.handle;


      if(!handle){

        return {
          title:item.product_title
        };

      }


      if(
        localizedProducts[handle]
      ){

        return localizedProducts[handle];

      }


      try{

        const response =
          await originalFetch(
            T.prefix +
            '/products/' +
            handle +
            '.js',
            {
              cache:'force-cache'
            }
          );


        if(!response.ok){
          throw new Error();
        }


        const product =
          await response.json();


        localizedProducts[handle] =
          product;


        return product;

      }

      catch(error){

        return {
          title:item.product_title
        };

      }

    }


    async function changeItem(
      key,
      quantity
    ){

      if(busy){
        return;
      }

      busy = true;


      try{

        await originalFetch(
          '/cart/change.js',
          {
            method:'POST',

            headers:{
              'Content-Type':'application/json'
            },

            body:
              JSON.stringify({
                id:key,
                quantity:quantity
              })
          }
        );

        await refresh();

      }

      catch(error){

        console.error(
          'MVD change',
          error
        );

      }

      busy = false;

    }


    async function addItem(
      variantId
    ){

      if(busy){
        return false;
      }

      busy = true;


      try{

        const response =
          await originalFetch(
            '/cart/add.js',
            {
              method:'POST',

              headers:{
                'Content-Type':'application/json'
              },

              body:
                JSON.stringify({
                  items:[
                    {
                      id:Number(
                        variantId
                      ),
                      quantity:1
                    }
                  ]
                })
            }
          );


        if(!response.ok){
          throw new Error();
        }


        busy = false;

        await refresh();

        return true;

      }

      catch(error){

        busy = false;

        return false;

      }

    }


    function renderShipping(cart){

      const total =
        Number(
          cart.total_price || 0
        );


      const progress =
        Math.min(
          100,
          (
            total /
            T.threshold
          ) * 100
        );


      shippingProgress.style.width =
        progress + '%';


      if(
        total >=
        T.threshold
      ){

        shippingText.textContent =
          T.free;

      }

      else{

        shippingText.textContent =
          T.missing.replace(
            '{amount}',
            money(
              T.threshold -
              total
            )
          );

      }

    }


    async function renderItems(cart){

      items.innerHTML = '';


      if(
        cart.items.length === 0
      ){

        items.hidden = true;
        empty.hidden = false;
        upsell.hidden = true;

        return;

      }


      items.hidden = false;
      empty.hidden = true;
      upsell.hidden = false;


      for(
        const item of cart.items
      ){

        const localized =
          await getLocalizedProduct(
            item
          );


        const localizedTitle =
          localized &&
          localized.title

            ? localized.title

            : item.product_title;


        const original =
          Number(
            item.original_line_price ||
            item.line_price ||
            0
          );


        const finalPrice =
          Number(
            item.final_line_price ||
            item.line_price ||
            0
          );


        let percentage = 0;


        if(
          original >
          finalPrice &&
          original > 0
        ){

          percentage =
            Math.round(
              (
                (
                  original -
                  finalPrice
                ) /
                original
              ) * 100
            );

        }


        const row =
          document.createElement(
            'div'
          );


        row.className =
          'mvd-item';


        row.innerHTML =

          '<a class="mvd-item-image" href="' +
            item.url +
          '">' +

            '<img src="' +
              (item.image || '') +
            '">' +

          '</a>' +


          '<div class="mvd-item-center">' +

            '<a class="mvd-item-name" href="' +
              item.url +
            '">' +

              safeText(
                localizedTitle
              ) +

            '</a>' +


            (
              item.variant_title &&
              item.variant_title !==
              'Default Title'

                ? '<div class="mvd-item-variant">' +
                    safeText(
                      item.variant_title
                    ) +
                  '</div>'

                : ''
            ) +


            '<div class="mvd-qty">' +

              '<button type="button" class="mvd-minus">−</button>' +

              '<span>' +
                item.quantity +
              '</span>' +

              '<button type="button" class="mvd-plus">+</button>' +

            '</div>' +


            '<button type="button" class="mvd-remove">' +
              T.remove +
            '</button>' +

          '</div>' +


          '<div class="mvd-item-right">' +

            '<span class="mvd-item-price">' +
              money(
                finalPrice
              ) +
            '</span>' +

            (
              original >
              finalPrice

                ? '<span class="mvd-item-old-price">' +
                    money(
                      original
                    ) +
                  '</span>'

                : ''
            ) +

            (
              percentage > 0

                ? '<span class="mvd-save-percent">' +
                    T.save.replace(
                      '{percent}',
                      percentage
                    ) +
                  '</span>'

                : ''
            ) +

          '</div>';


        row.querySelector(
          '.mvd-minus'
        ).onclick =
          function(){

            changeItem(
              item.key,
              Math.max(
                0,
                item.quantity - 1
              )
            );

          };


        row.querySelector(
          '.mvd-plus'
        ).onclick =
          function(){

            changeItem(
              item.key,
              item.quantity + 1
            );

          };


        row.querySelector(
          '.mvd-remove'
        ).onclick =
          function(){

            changeItem(
              item.key,
              0
            );

          };


        items.appendChild(
          row
        );

      }

    }


    function getDiscountNames(cart){

      const names = [];


      function addName(value){

        const clean =
          String(value || '')
            .trim();


        if(!clean){
          return;
        }


        const exists =
          names.some(
            function(name){

              return (
                name.toLowerCase() ===
                clean.toLowerCase()
              );

            }
          );


        if(!exists){
          names.push(clean);
        }

      }


      if(
        Array.isArray(
          cart.cart_level_discount_applications
        )
      ){

        cart
          .cart_level_discount_applications
          .forEach(
            function(app){

              addName(
                app.title ||
                app.code
              );

            }
          );

      }


      cart.items.forEach(
        function(item){

          if(
            !Array.isArray(
              item.line_level_discount_allocations
            )
          ){
            return;
          }


          item
            .line_level_discount_allocations
            .forEach(
              function(allocation){

                if(
                  allocation.discount_application
                ){

                  addName(
                    allocation
                      .discount_application
                      .title ||

                    allocation
                      .discount_application
                      .code
                  );

                }

              }
            );

        }
      );


      return names;

    }


    function renderDiscounts(cart){

      const names =
        getDiscountNames(
          cart
        );


      if(
        names.length === 0
      ){

        activeDiscounts.hidden = true;
        activeDiscountTags.innerHTML = '';

        return;

      }


      activeDiscounts.hidden = false;
      activeDiscountTags.innerHTML = '';


      names.forEach(
        function(name){

          const tag =
            document.createElement(
              'span'
            );


          tag.className =
            'mvd-discount-tag';


          tag.textContent =
            name;


          activeDiscountTags.appendChild(
            tag
          );

        }
      );

    }


    function renderSummary(cart){

      let original = 0;
      let finalPrice = 0;


      cart.items.forEach(
        function(item){

          original +=
            Number(
              item.original_line_price ||
              item.line_price ||
              0
            );


          finalPrice +=
            Number(
              item.final_line_price ||
              item.line_price ||
              0
            );

        }
      );


      const saving =
        Math.max(
          Number(
            cart.total_discount ||
            0
          ),
          original -
          finalPrice
        );


      savingValue.textContent =
        saving > 0

          ? '-' +
            money(saving)

          : money(0);


      checkout.textContent =
        T.checkout.replace(
          '{total}',
          money(
            cart.total_price
          )
        );


      checkout.href =
        '/checkout';


      renderDiscounts(
        cart
      );

    }


    let promoOpen = false;


    promoToggle.onclick =
      function(){

        promoOpen =
          !promoOpen;


        promoContent.hidden =
          !promoOpen;


        promoSymbol.textContent =
          promoOpen
            ? '−'
            : '+';

      };


    promoApply.onclick =
      async function(){

        const code =
          promoInput
            .value
            .trim();


        if(!code){

          promoMessage.textContent =
            T.promoEmpty;

          return;

        }


        promoApply.disabled = true;

        promoApply.textContent =
          T.applying;

        promoMessage.textContent = '';


        try{

          await originalFetch(
            '/discount/' +
            encodeURIComponent(code) +
            '?redirect=/cart',
            {
              credentials:'same-origin',
              cache:'no-store'
            }
          );


          await new Promise(
            function(resolve){

              setTimeout(
                resolve,
                250
              );

            }
          );


          const updated =
            await getCart();


          renderShipping(updated);

          await renderItems(updated);

          renderSummary(updated);

          await renderUpsell(updated);


          const names =
            getDiscountNames(
              updated
            );


          const found =
            names.some(
              function(name){

                return (
                  name
                    .toLowerCase()
                    .indexOf(
                      code.toLowerCase()
                    ) !== -1
                );

              }
            );


          promoMessage.textContent =
            found
              ? T.promoApplied
              : T.promoInvalid;

        }

        catch(error){

          promoMessage.textContent =
            T.promoInvalid;

        }


        promoApply.disabled = false;

        promoApply.textContent =
          T.apply;

      };


    promoInput.addEventListener(
      'keydown',
      function(event){

        if(
          event.key ===
          'Enter'
        ){

          event.preventDefault();

          promoApply.click();

        }

      }
    );


    async function loadAccessories(){

      if(
        accessoryProducts
      ){

        return accessoryProducts;

      }


      try{

        const response =
          await originalFetch(
            T.collection,
            {
              cache:'no-store'
            }
          );


        if(!response.ok){
          throw new Error();
        }


        const data =
          await response.json();


        accessoryProducts =
          data.products || [];


        return accessoryProducts;

      }

      catch(error){

        accessoryProducts = [];

        return [];

      }

    }


    /* =========================================
       BENEFICES ACCESSOIRES
    ========================================= */

    function productBenefit(product){

      const text =
        (
          (product.handle || '') +
          ' ' +
          (product.title || '')
        )
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g,'');


      /* STYLO A EMBOUTS METALLIQUES */

      if(
        text.indexOf('embouts-metalliques') !== -1 ||
        text.indexOf('metal-tips') !== -1 ||
        text.indexOf('puntas-metalicas') !== -1
      ){

        return lang === 'fr'
          ? '⚡ Posez plusieurs diamants à la fois'
          : lang === 'es'
            ? '⚡ Coloca varios diamantes a la vez'
            : '⚡ Place multiple diamonds at once';

      }


      /* VALISE 60 CELLULES */

      if(
        text.indexOf('valise') !== -1 ||
        text.indexOf('60-cell') !== -1 ||
        text.indexOf('60-cellules') !== -1 ||
        text.indexOf('60 compartimentos') !== -1
      ){

        return lang === 'fr'
          ? '🧰 Rangez vos diamants et votre matériel'
          : lang === 'es'
            ? '🧰 Guarda tus diamantes y tu material'
            : '🧰 Store your diamonds & tools';

      }


      /* BOITE 56 CELLULES */

      if(
        text.indexOf('56-cell') !== -1 ||
        text.indexOf('56-cellules') !== -1 ||
        text.indexOf('56 compartimentos') !== -1
      ){

        return lang === 'fr'
          ? '💎 Organisez et séparez facilement vos diamants'
          : lang === 'es'
            ? '💎 Organiza y separa fácilmente tus diamantes'
            : '💎 Easily organize & separate your diamonds';

      }


      /* PLATEAU DE TRI */

      if(
        text.indexOf('plateau') !== -1 ||
        text.indexOf('sorting-tray') !== -1 ||
        text.indexOf('tray') !== -1 ||
        text.indexOf('bandeja') !== -1
      ){

        return lang === 'fr'
          ? '🛡️ Plus pratique et limite les renversements'
          : lang === 'es'
            ? '🛡️ Más práctico y ayuda a evitar derrames'
            : '🛡️ Easier to use and helps prevent spills';

      }


      /* CLASSEUR */

      if(
        text.indexOf('classeur') !== -1 ||
        text.indexOf('binder') !== -1 ||
        text.indexOf('portfolio') !== -1 ||
        text.indexOf('carpeta') !== -1 ||
        text.indexOf('album') !== -1
      ){

        return lang === 'fr'
          ? '🖼️ Protégez et rangez vos créations terminées'
          : lang === 'es'
            ? '🖼️ Protege y guarda tus creaciones terminadas'
            : '🖼️ Protect & store your finished creations';

      }


      /* TABLETTE LUMINEUSE */

      if(
        text.indexOf('tablette-lumineuse') !== -1 ||
        text.indexOf('light-pad') !== -1 ||
        text.indexOf('light-board') !== -1 ||
        text.indexOf('light-table') !== -1 ||
        text.indexOf('lumineuse') !== -1
      ){

        return lang === 'fr'
          ? '💡 Distinguez les symboles plus facilement'
          : lang === 'es'
            ? '💡 Distingue los símbolos más fácilmente'
            : '💡 See the symbols more easily';

      }


      /* PINCE */

      if(
        text.indexOf('pince') !== -1 ||
        text.indexOf('tweezer') !== -1 ||
        text.indexOf('tweezers') !== -1 ||
        text.indexOf('pinza') !== -1
      ){

        return lang === 'fr'
          ? '🎯 Ajustez et retirez vos diamants avec précision'
          : lang === 'es'
            ? '🎯 Ajusta y retira tus diamantes con precisión'
            : '🎯 Adjust & remove diamonds with precision';

      }


      /* CADRE */

      if(
        text.indexOf('cadre') !== -1 ||
        text.indexOf('frame') !== -1 ||
        text.indexOf('marco') !== -1
      ){

        return lang === 'fr'
          ? '✨ Exposez votre création une fois terminée'
          : lang === 'es'
            ? '✨ Expón tu creación una vez terminada'
            : '✨ Display your creation once finished';

      }


      /* BOITE / RANGEMENT GENERIQUE */

      if(
        text.indexOf('boite') !== -1 ||
        text.indexOf('storage') !== -1 ||
        text.indexOf('box') !== -1 ||
        text.indexOf('rangement') !== -1 ||
        text.indexOf('caja') !== -1
      ){

        return lang === 'fr'
          ? '💎 Gardez votre matériel parfaitement organisé'
          : lang === 'es'
            ? '💎 Mantén todo tu material perfectamente organizado'
            : '💎 Keep your supplies perfectly organized';

      }


      /* BENEFICE GENERIQUE */

      return lang === 'fr'
        ? '✨ Rendez votre Diamond Painting encore plus agréable'
        : lang === 'es'
          ? '✨ Haz que tu Diamond Painting sea aún más agradable'
          : '✨ Make your Diamond Painting experience even better';

    }


    async function renderUpsell(cart){

      const products =
        await loadAccessories();


      slider.innerHTML = '';


      const cartIds =
        cart.items.map(
          function(item){

            return Number(
              item.product_id
            );

          }
        );


      products.forEach(
        function(product){

          if(
            cartIds.indexOf(
              Number(product.id)
            ) !== -1
          ){
            return;
          }


          const variant =
            product.variants.find(
              function(v){

                return v.available;

              }
            ) ||
            product.variants[0];


          if(!variant){
            return;
          }


          const productPrice =
            Math.round(
              parseFloat(
                variant.price
              ) * 100
            );


          let image = '';


          if(
            product.images &&
            product.images.length
          ){

            image =
              product.images[0].src ||
              product.images[0];

          }


          const productUrl =
            T.prefix +
            '/products/' +
            product.handle;


          const card =
            document.createElement(
              'div'
            );


          card.className =
            'mvd-upsell-card';


          card.innerHTML =

            '<a href="' +
              productUrl +
            '">' +

              '<img src="' +
                image +
              '">' +

            '</a>' +

            '<div>' +

              '<a class="mvd-upsell-name" href="' +
                productUrl +
              '">' +

                safeText(
                  product.title
                ) +

              '</a>' +

              '<span class="mvd-upsell-benefit">' +

                productBenefit(
                  product
                ) +

              '</span>' +

              '<span class="mvd-upsell-price">' +

                money(
                  productPrice
                ) +

              '</span>' +

              '<button type="button" class="mvd-upsell-add">' +

                T.add +

              '</button>' +

            '</div>';


          const button =
            card.querySelector(
              '.mvd-upsell-add'
            );


          button.onclick =
            async function(){

              button.disabled = true;

              button.textContent =
                T.adding;


              await addItem(
                variant.id
              );


              button.disabled = false;

              button.textContent =
                T.add;

            };


          slider.appendChild(
            card
          );

        }
      );

    }


    prev.onclick =
      function(){

        slider.scrollBy({
          left:-270,
          behavior:'smooth'
        });

      };


    next.onclick =
      function(){

        slider.scrollBy({
          left:270,
          behavior:'smooth'
        });

      };


    async function refresh(){

      try{

        const cart =
          await getCart();


        renderShipping(
          cart
        );


        await renderItems(
          cart
        );


        renderSummary(
          cart
        );


        await renderUpsell(
          cart
        );

      }

      catch(error){

        console.error(
          'MVD CART',
          error
        );

      }

    }


    document.addEventListener(
      'cart:refresh',
      refresh
    );


    document.addEventListener(
      'cart:updated',
      refresh
    );


    document.addEventListener(
      'mvd:cart-refresh',
      refresh
    );


    document.addEventListener(
      'mvd:cart-open',
      openCart
    );


    refresh();

  }


  if(
    document.readyState ===
    'loading'
  ){

    document.addEventListener(
      'DOMContentLoaded',
      initMvdCart
    );

  }

  else{

    initMvdCart();

  }

})();